import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Layout, Row, Col, Select } from 'antd'
import _ from 'lodash'

@inject((store: any) => {
    const { popupStore, drugsStore, companiesStore } = store
    return { popupStore, drugsStore, companiesStore }
})
@observer
export default class DrugAdditionalDataPopup extends Component<any, any> {
    componentDidMount() {}
    renderDrugPacks = drugPacks => {
        //let index=-1;
        const listItems = drugPacks.map((item, index) => {
            let pack = item.package_description + ' - ' + item.quantity + ' - ' + item.max_price
            return <li key={index}>{pack}</li>
        })
        return <ul>{listItems}</ul>
    }
    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore, drugsStore } = this.props
        const { drug } = drugsStore

        return (
            <Modal
                title={'מידע נוסף'}
                visible={popupStore.popupType === 'drugsAdditionalData'}
                cancelText="ביטול"
                onOk={this.closePopup}
                onCancel={this.closePopup}
            >
                <div style={{ paddingBottom: '2rem' }}>
                    <Row style={{ display: 'flex', alignItems: 'center' }}>
                        <Col xs={24} style={{ padding: '0 0.5rem' }}>
                            {(drug.dosage_form || drug.dosage_form_heb || drug.dosage_form_eng) && (
                                <div style={{ paddingBottom: '1rem' }}>
                                    <strong>מינון : </strong>
                                    <div>
                                        {drug.dosage_form} , {drug.dosage_form_heb} ,{drug.dosage_form_eng}
                                    </div>
                                </div>
                            )}
                            {(drug.usage_form_heb || drug.usage_form_eng) && (
                                <div style={{ paddingBottom: '1rem' }}>
                                    <strong>שימוש : </strong>
                                    <div>
                                        {drug.usage_form_heb} , {drug.usage_form_eng}
                                    </div>
                                </div>
                            )}
                            {drug.limitations && (
                                <div style={{ paddingBottom: '1rem' }}>
                                    <strong>הגבלות : </strong> <div>{drug.limitations}</div>
                                </div>
                            )}
                            {drug.indications && (
                                <div style={{ paddingBottom: '1rem' }}>
                                    <strong>הוראות : </strong> <div>{drug.indications}</div>
                                </div>
                            )}
                            {drug.drugPacks && (
                                <div style={{ paddingBottom: '1rem' }}>
                                    <strong>אריזות : </strong>
                                    <div> {this.renderDrugPacks(drug.drugPacks)}</div>
                                </div>
                            )}
                        </Col>
                    </Row>
                </div>
            </Modal>
        )
    }
}
